// import dayjs from 'dayjs';
// import utc from 'dayjs/plugin/utc';
import cookies from 'js-cookie';
import { timeFormatType, timezone, currencyUnit, currencyFormatType, COUNTRY_CODE_MAP } from './const';
import { sendLog, getKwaiLog } from './log';
import { callApp, callAppNew } from './call-app';
import { UNIQUE_ID_COOKIE_KEY, P_STR_COOKIE_KEY } from './uniqueId';
import _ from 'lodash';

// dayjs.extend(utc);

export function isFacebookApp() {
    const ua = navigator.userAgent || navigator.vendor || window.opera;
    return (ua.indexOf('FBAN') > -1) || (ua.indexOf('FBAV') > -1);
}

export function isAndroid() {
    const ua = navigator.userAgent || navigator.vendor || window.opera;
    return ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1; 
}

export function toFixedWithOutRounding(val: number, n: number = 1) {
    const re = new RegExp(`^\\d+(?:\\.\\d{0,${n}})?`);

    return Number(val.toString().match(re));
}

// <10000 正常展示  10000<=x <1000000    >= 100万 m单位  10亿 b
export function formateNum(num: number, fixedNumber?: number) {
    if (num >= 1000000000) {
        return `${toFixedWithOutRounding(num / 1000000000, fixedNumber)}B`;
    }
    if (num >= 1000000) {
        return `${toFixedWithOutRounding(num / 1000000, fixedNumber)}M`;
    }
    if (num >= 10000) {
        return `${toFixedWithOutRounding(num / 1000, fixedNumber)}K`;
    }
    return num;
}

/**
 * 15以下显示15
 * 16到1万之间显示实际准确数额，如16、2341
 * 超过1万，保留1位小数点，显示2w、23.1w
 */
export function formateNumPhoto(num: number, fixedNumber?: number) {
    if (num <= 15) {
        return 15;
    }
    if (num >= 1000000000) {
        return `${toFixedWithOutRounding(num / 1000000000, fixedNumber)}B`;
    }
    if (num >= 1000000) {
        return `${toFixedWithOutRounding(num / 1000000, fixedNumber)}M`;
    }
    if (num >= 10000) {
        return `${toFixedWithOutRounding(num / 1000, fixedNumber)}K`;
    }
    return num;
}

// 版本对比
export function compareVersion(vStr1: string, vStr2: string) {
    const v1 = vStr1.split('.');
    const v2 = vStr2.split('.');
    const len = Math.max(v1.length, v2.length);

    while (v1.length < len) {
        v1.push('0');
    }
    while (v2.length < len) {
        v2.push('0');
    }

    for (let i = 0; i < len; i++) {
        const num1 = parseInt(v1[i], 10);
        const num2 = parseInt(v2[i], 10);

        if (num1 > num2) {
            return 1;
        }

        if (num1 < num2) {
            return -1;
        }
    }
    return 0;
}

// export function dateFormat(
//     date: number | Date,
//     formatStr: string = timeFormatType
// ) {
//     return dayjs.utc(Number(date) - timezone * 3600 * 1000).format(formatStr);
// }

// 本地格式化
export const toLocaleString = (value: number) => {
    return value.toLocaleString(currencyFormatType);
};

/**
 *  Cash&Points数值仅能展示六位数
 * Cash数值缩写：
 * 默认保留两位小数，最多展示至R$9999.99
 * 超过四位数，截位，保留一位小数，最多展示至R$99999.9
 * 超过五位数，截位，取整，最多展示至R$999999
 * 后续不做处理
 * @param val
 */
export const fomateCash = (val: number) => {
    if (val < 10 ** 4) {
        return toLocaleString(val);
    }

    if (val < 10 ** 5) {
        return toLocaleString(toFixedWithOutRounding(val, 1));
    }

    if (val < 10 ** 6) {
        return toLocaleString(toFixedWithOutRounding(val, 0));
    }

    if (val < 10 ** 9) {
        return `${toLocaleString(toFixedWithOutRounding(val / 10 ** 3, 0))}K`;
    }

    return `${toLocaleString(999999)}K`;
};

/**
 * 格式化金币展示
 * @param val
 */
export const fomatePoints = (val: number) => {
    if (val < 10 ** 6) {
        return toLocaleString(val);
    }

    if (val < 10 ** 10) {
        return `${toLocaleString(toFixedWithOutRounding(val / 10 ** 6, 2))}M`;
    }

    if (val < 10 ** 11) {
        return `${toLocaleString(toFixedWithOutRounding(val / 10 ** 6, 1))}M`;
    }

    if (val < 10 ** 12) {
        return `${toLocaleString(toFixedWithOutRounding(val / 10 ** 6, 0))}M`;
    }

    return `${toLocaleString(999999)}M`;
};

export const serialize = function (obj: Record<string, any>) {
    const str = [];
    for (const p in obj) {
    // eslint-disable-next-line no-prototype-builtins
        if (obj.hasOwnProperty(p)) {
            str.push(`${encodeURIComponent(p)}=${encodeURIComponent(obj[p])}`);
        }
    }
    return str.join('&');
};

export const getQuery = function () {
    const url = location.search; // 获取url中"?"符后的字串
    const theRequest = Object.create(null);
    if (url.indexOf('?') !== -1) {
        const str = url.substr(1);
        const strs = str.split('&');
        for (let i = 0; i < strs.length; i++) {
            theRequest[strs[i].split('=')[0]] = decodeURIComponent(strs[i].split('=')[1]);
        }
    }
    return theRequest;
};
// 跳转onelink
export function jumpOneLink(
    url: string,
    logConfig?: { type: 'click' | 'show' | 'pv'; name: string; value?: any },
    scheme: string = 'home',
    clickLinkTogp?: boolean
) {
    if (logConfig) {
        sendLog(logConfig);
    }

    // 如果是fb浏览器，则直接唤起gp
    if(clickLinkTogp) {
        callAppNew({
            path: scheme,
            onelink: url,
        })
    }
    else if (isAndroid() && isFacebookApp()) {
        window.top.location.href = url;
    } else {
        callApp({
            path: scheme,
            onelink: url,
        }, null);
    }

}

// 视频分享sideloading下载
export function jumpDownloadPackage(
    callback: Function,
    logConfig?: { type: 'click' | 'show' | 'pv'; name: string; value?: any },
    scheme: string = 'home'
) {
    if (logConfig) {
        sendLog(logConfig);
    }
    callApp({
        timeout: 2500,
        onelink: null,
        path: scheme,
    }, callback);
    // window.top.location.href = `ikwai://${scheme}`
    // callback()
}


export function objToQueryString(obj: Record<string, any>, isEncode: boolean) {
    if (typeof obj !== 'object') {
        return '';
    }
    const str = [];
    for (const p in obj) {
        if (obj.hasOwnProperty(p)) {
            if (isEncode) {
                str.push(`${encodeURIComponent(p)}=${encodeURIComponent(obj[p])}`);
            } else {
                str.push(`${p}=${obj[p]}`);
            }
        }
    }
    return str.join('&');
}

export function getKpn(host: string, queryKpn: string) {
    let kpn = cookies.get('kpn') || queryKpn;
    if (!kpn) {
        switch (host) {
            case ('m.kwai-pro.com' || 'm.kwai.com'):
                kpn = 'KWAI';
                break;
            case 'm.kwaiapps.com':
                kpn = 'KWAI.ME';
                break;
            case ('m.snackvideo.com' || 'm.uvfuns.com' || 'snackvideo.kwai.com'):
                kpn = 'KWAI_BULLDOG';
                break;
            default:
                kpn = 'KWAI';
        }
    }
    return kpn;
}

export const isElementInViewport = (el: HTMLElement, percent?: number) => {
    // 获取元素是否在可视区域, el -> 获取的元素dom, percent -> 元素高度的倍数
    const rect = el.getBoundingClientRect();
    const elHeight = el.offsetHeight; // 元素高度
    const elWidth = el.offsetWidth; // 元素宽度
    const viewHeight = (window.innerHeight || document.documentElement.clientHeight) + ((elHeight || 0) * percent);
    const viewWidth = (window.innerWidth || document.documentElement.clientWidth) + ((elWidth || 0) * percent);
    return (
        rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <= viewHeight &&
    rect.right <= viewWidth
    );
};

/**
 * 获取ikwai协议的target url
 * @param href
 * @param clickSource 点击区域
 * @param extra extra 参数，如果为string, 兼容groupId
 * @returns
 */
export function getTargetUrl(href: string, clickSource?: string, extra?: string | any) {
    const deviceId = (cookies.get('_did') || '') as string;
    const uId = (cookies.get(UNIQUE_ID_COOKIE_KEY) || '') as string;
    const pstrId = (cookies.get(P_STR_COOKIE_KEY) || '') as string;
    const { message, initData } = window.__INITIAL_STATE__ || {};
    let url = href;
    let p = '&';
    if (href.indexOf('?') === -1) {
        p = '?';
    }
    url = `${href + p}web_did=${deviceId}`;
    if (clickSource) {
        url += `&click_source=${clickSource}`;
    }
    if (uId) {
        url += `&web_uq=${uId}`;
    }
    if (pstrId) {
        url += `&web_pstr=${pstrId}`;
    }

    if (!getQuery()?.web_session_id) {
        const webLogger = getKwaiLog();
        url += `&web_session_id=${webLogger.sessionId}`;
    }
    
    // todo: 客户端错误临时解决方案：替换链接里的photoid为点击卡片的photoid
    try {
        if (clickSource && ['trending', 'cover_work_v2'].includes(clickSource) && extra?.photoId) {
            url = url.replace('short_key', 'short_key_raw').replaceAll(initData?.photoId, extra.photoId);
            delete extra.photoId;
        }
    } catch (error) {
        console.error(error);
    }

    if (extra) {
    // 兼容extra 为groupId的情况
        if (typeof extra === 'string') {
            url += `&groupId=${extra}`;
        } else {

            // 自动从message取对应的实验组信息
            if (!extra.groupId && message.groupId) {
                extra.groupId = message.groupId;
            }
            if (!extra.metaGroupId && message.metaConfig) {
                extra.metaGroupId = message.metaConfig.groupId;
            }
            url += `&${objToQueryString(extra, true)}`;
        }
    }
    
    return encodeURIComponent(url);
}


export function getTargetUrlFunc(href?: string): Function {
    let url = href;
    if (!href) {
        url = window.location.href;
    }
    return function (clickSource: string, extra: any) {
        return getTargetUrl(url, clickSource, extra);
    };
}

export function getCommonTargetUrl(clickSource: string): string {
    const deviceId = (cookies.get('_did') || '') as string;
    const message = window.__INITIAL_STATE__?.message || {};
    let url = '';
    const href = window.location.href;
    let p = '&';
    if (href.indexOf('?') === -1) {
        p = '?';
    }
    url = `${href + p}web_did=${deviceId}`;
    if (clickSource) {
        url += `&click_source=${clickSource}`;
    }
    const extra = {} as any;
    // 自动从message取对应的实验组信息
    if (message.pageConf && message.pageConf.groupId) {
        extra.groupId = message.pageConf.groupId;
    }
    if (message.metaConfig && message.metaConfig.groupId) {
        extra.metaGroupId = message.metaConfig.groupId;
    }
    url += `&${objToQueryString(extra, true)}`;
    return encodeURIComponent(url);
}

export function getOnelink(
    onelinkBase: string,
    clickSource?: string
) {
    const targetUrl = getCommonTargetUrl(clickSource);
    const query = getQuery();
    const deviceId = (cookies.get('_did') || '') as string;
    const af_sub1 = JSON.stringify({
        share_id: query.share_id || `${deviceId}_${new Date().getTime()}`,
        shareInfo: {
            target_url: targetUrl,
        },
    });
    let p = '&';
    if (onelinkBase.indexOf('?') === -1) {
        p = '?';
    }
    return `${onelinkBase}${p}af_sub1=${af_sub1}&af_adset=${clickSource}&utm_source=kwai_share_h5&utm_campaign=${clickSource}`;
}

export function useNosnippet(source):boolean {
    if (source) {
        return ['julia', 'kelly'].indexOf(source) !== -1;
    }
    return false;
}

export function isIphoneSafari(){
    const ua = navigator.userAgent.toLowerCase();
    if (ua.indexOf('applewebkit') > -1 && ua.indexOf('mobile') > -1 && ua.indexOf('safari') > -1 &&
        ua.indexOf('linux') === -1 && ua.indexOf('android') === -1 && ua.indexOf('chrome') === -1 &&
        ua.indexOf('ios') === -1 && ua.indexOf('browser') === -1) {
        return true;
    }
    return false;
}

export function isIOSClient() {
    const ua = navigator.userAgent;
    return /(iPhone|iPad|iPod|iOS|MAC OS X)/i.test(ua);
}

export function copy(text) {
    // eslint-disable-next-line no-underscore-dangle
    function __createFakeElement(value) {
        const isRTL = document.documentElement.getAttribute('dir') === 'rtl';
        const fakeElement = document.createElement('textarea'); // Prevent zooming on iOS
      
        fakeElement.style.fontSize = '12pt'; // Reset box model
      
        fakeElement.style.border = '0';
        fakeElement.style.padding = '0';
        fakeElement.style.margin = '0'; // Move element out of screen horizontally
      
        fakeElement.style.position = 'absolute';
        fakeElement.style[isRTL ? 'right' : 'left'] = '-9999px'; // Move element to the same position vertically
      
        const yPosition = window.pageYOffset || document.documentElement.scrollTop;
        fakeElement.style.top = ''.concat(yPosition.toString(), 'px');
        fakeElement.setAttribute('readonly', '');
        fakeElement.value = value;
        return fakeElement;
    }
    const textArea = __createFakeElement(text);
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    const successful = document.execCommand('copy');
    const msg = successful ? 'successful' : 'fail';
    console.log(`Fallback: Copying text command was ${msg}`);
  
    if (!successful && navigator.clipboard) {
        navigator.clipboard.writeText(text).then(() => {
            console.log('try navigator api copy success');
        }).catch(() => {
            console.log('try navigator api copy fail');
        });
    }
  
    document.body.removeChild(textArea);
}

export function getNetworkType() {
    const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    return connection?.type || connection?.effectiveType;
}

/**
 * 生成nano id
 * @return {string} 16长度的字符串
 */
export function nanoId() {
    const ts = ((Math.random() * 1e9) >>> 0);
    const randomer = [];
    const seed = '0123456789ABCDEF';
    for (let i = 0; i < 7; i++) {
        randomer.push(seed.charAt(Math.random() * 16));
    }

    return ts + randomer.join('');
}

export const getIosMainVersion = () => {
    const ua = navigator.userAgent.toLowerCase();
    let version = null;
    if (ua.indexOf('like mac os x') > 0) {
        const reg = /os [\d._]+/gi;
        const v_info = ua.match(reg);
        version = (`${v_info  }`).replace(/[^0-9|_.]/ig, '').replace(/_/ig, '.'); // 得到版本号9.3.2或者9.0
        version = parseInt(version.split('.')[0]); // 得到版本号第一位
    }

    return version;
};

export const getAndroidMainVersion = () => {
    const ua = navigator.userAgent.toLowerCase();
    let version = null;
    if (ua.indexOf('android') > 0) {
        const reg = /android [\d._]+/gi;
        const v_info = ua.match(reg);
        version = (`${v_info  }`).replace(/[^0-9|_.]/ig, '').replace(/_/ig, '.'); // 得到版本号4.2.2
        version = parseInt(version.split('.')[0]);// 得到版本号第一位
    }

    return version;
};

export const getCountryCode = (code: string): string => {
    return  COUNTRY_CODE_MAP[code?.toLowerCase()] || code;
};
// 将http转换称https
export const formatUrls = function (url: string) {
    if (url.startsWith('http:')) {
        return url.replace(/http:/, 'https:');
    }
    return url;
};
export const getVideoClipType = (videoWidth: number, videoHeight: number): number => {
    if (videoWidth === 0 && videoHeight === 0) {
        return 0; // 全屏cover
    }
    if (typeof window !== 'undefined') {
        const h = videoHeight / (videoWidth / window.innerWidth);
        if (h >= window.innerHeight) {
            return 0; // 全屏cover
        }
        if (h >= window.innerHeight - 120 * 2) {
            return 1; // 切底cover
        }
        return 2; // 全屏contain
    }
    return 2;
};

// 设计稿尺寸转PX
let WINDOW_WIDTH = 0;
export const designSize2Px = (elementSize: number, designSize = 828) => {
    if (!WINDOW_WIDTH){ WINDOW_WIDTH = window.innerWidth;}
    return (elementSize/designSize) * WINDOW_WIDTH;
};

export const generateOnelink = (pid: string, appName: string, url: string, kpn: string) => {
    const onlink = {
        me: 'https://k.kw.ai/ka',
        pro: 'https://k.kw.ai/ka',
        snack: 'https://k.sck.io/ka',
    };

    // 动态生成onelink
    const genOnelink = () => {
        const prefix = `${onlink[appName]}?pid=${pid}&is_retargeting=true&af_force_deeplink=true&deep_link_sub1=pid%253D${pid}&kpn=${kpn}`;
        const afdpStr = url ? 
            `ikwai://webview?url=${encodeURIComponent(`${url}`)}&ug_referrer=pid%3D${pid}` 
            : `ikwai://home?ug_referrer=pid%3D${pid}`;
        const deepLinkStr = url ? `ikwai://webview?url=${encodeURIComponent(url)}` : 'ikwai://home';
        const onelink = `${prefix}&af_dp=${encodeURIComponent(afdpStr)}&deep_link_value=${encodeURIComponent(deepLinkStr)}`;
        return onelink;
    };

    return genOnelink();
};

/**
 * 将以分为单位的金额数值格式化为localeString
 * @param val 金额，单位分
 * @returns string
 */
export const cashFormat = (val: number) => `${currencyUnit}${toLocaleString(val / 100)}`;
